import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication.service';
import { SessionService } from 'src/app/core/session.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Panel } from 'src/app/enums';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public currentUser;
  panelOptions = Panel;
  public title;
  flagImage = "";

  constructor(
    public auth: AuthenticationService,
    private router: Router, private route: ActivatedRoute,
  ) {
    this.currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : '';
    this.auth.currentUser.subscribe(x => { this.currentUser = x });
    this.title = localStorage.getItem('title') ? localStorage.getItem('title') : '';
    this.flagImage = localStorage.getItem('headerImage') ? localStorage.getItem('headerImage') : ''; 
  }

  ngOnInit(): void {
  }

  logout() {
    this.auth.logout().subscribe(data => {
      this.router.navigate(['/login']);
    }, err => {
      this.router.navigate(['/login']);
    });
  }

  switchportal() {
    this.router.navigate(['/portalLanding']);
  }

  getTitle() {
    let label = '';
    label = this.route.snapshot.data['title'];
    return label;
  }

  isAdmin() {
    //return this.auth.isAdmin();
    return true;
  }
  RefreshToken() {
    this.auth.RefreshToken();
  }


}
